<div class="row" *ngIf="!loading">
  <div class="col-10 offset-1 col-md-8 offset-md-2 col-lg-6 offset-lg-3 col-xl-4 offset-xl-4">
    <div class="login-wrap">
      <h2>Bypass Login</h2>

      <div *ngIf="!bypassEnabled" class="text-center">
        <p>Bypass authentication is not enabled on this environment.</p>
        <a routerLink="/" class="btn btn-secondary">Back to Login</a>
      </div>

      <form *ngIf="bypassEnabled" [formGroup]="form">
        <table class="simple-form" aria-hidden="true">
          <tr>
            <th style="width: 100px;"><label>Email</label></th>
            <td>
              <div class="form-group">
                <input type="email" class="form-control" formControlName="email" placeholder="Enter email address" />
              </div>
            </td>
          </tr>
          <tr>
            <th style="width: 100px;"><label>Password</label></th>
            <td>
              <div class="form-group">
                <input type="password" class="form-control" formControlName="password" placeholder="Enter password" />
              </div>
            </td>
          </tr>
        </table>

        <div class="btn-wrap">
          <div class="row">
            <div class="col-6">
              <app-button text="Cancel" width="fill" variant="secondary" href="/" />
            </div>
            <div class="col-6">
              <app-button width="fill" text="Log In" [isBusy]="isProcessing" [disabled]="!form.valid || isProcessing" (clicked)="onSubmit()" />
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
